/**
 * auth feature routes — owned by web-admin (login page by lead).
 * Add child routes here (this file and everything under features/auth/ belong to the owner).
 * The pathless "authFeature" route is registered once in src/app/router.tsx (frozen).
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';

export const authFeature = createRoute({ getParentRoute: () => rootRoute, id: 'auth' });

export const loginRoute = createRoute({
  getParentRoute: () => authFeature,
  path: '/login',
  component: lazyRouteComponent(() => import('./pages/LoginPage'), 'LoginPage'),
});

/** Kakao / Zalo redirect back (`<WEB_BASE_URL>/auth/callback/<provider>`, §15 #417–#426) */
export const socialCallbackRoute = createRoute({
  getParentRoute: () => authFeature,
  path: '/auth/callback/$provider',
  component: lazyRouteComponent(() => import('./pages/SocialCallbackPage'), 'SocialCallbackPage'),
});

/** the page the native app opens in the system browser for a social sign-in */
export const appStartRoute = createRoute({
  getParentRoute: () => authFeature,
  path: '/auth/app',
  component: lazyRouteComponent(() => import('./pages/AppStartPage'), 'AppStartPage'),
});

export const authRouteTree = authFeature.addChildren([
  loginRoute,
  socialCallbackRoute,
  appStartRoute,
]);
